const _ = require("lodash");
const {findOptionalArgument, findArguments} = require("../util/ParserHelpers");

const mirrorParser = function(ps) {
	const options = {
		x: false, // flip on x-axis
		y: false, // flip on y-axis
	};

	let optArg;
	// eslint-disable-next-line no-cond-assign
	while ((optArg = findOptionalArgument(ps))) {
		const text = optArg.text;
		if (_.keys(options).includes(text)) {
			options[text] = true;
		} else {
			ps.pushError(
				`Unrecognized optional argument: "${text}". Valid arguments: "x" and/or "y".`
			);
		}
	}

	const args = findArguments(ps, 1);
	if (!args || args[0].getRest() === "") {
		ps.pushError("The mirror command requires an inner command as well.");
		return false;
	}

	return [
		{
			type: "mirror",
			options,
			children: ps.parseMath(args[0]),
		},
	];
};

const mirrorNode = {
	draw(rc, x, y, node, measure) {
		const {context} = rc;
		const {options} = node;
		const {x: xAxis, y: yAxis} = options;
		const {width} = measure;
		let childX = x;
		node.children.forEach((child, i) => {
			context.save();
			context.translate(childX + (yAxis ? width : 0), y);
			context.scale(yAxis ? -1 : 1, xAxis ? -1 : 1);
			rc.drawNode(rc, 0, 0, node.children[i]);
			if (yAxis) {
				childX -= measure.childWidths[i];
			} else {
				childX += measure.childWidths[i];
			}
			context.restore();
		});
	},
	measure(rc, fontInfo, props, node) {
		let top = 0;
		let bottom = 0;
		let width = 0;
		const childWidths = [];

		node.children.forEach((childNode, i) => {
			const childMeasure = rc.measureNode(
				rc,
				fontInfo,
				props,
				node.children[i]
			);
			top = Math.max(top, childMeasure.top);
			bottom = Math.max(bottom, childMeasure.bottom);
			childWidths.push(childMeasure.width);
			width += childMeasure.width;
		});
		return _.extend({
			top,
			bottom,
			width,
			childWidths,
		});
	},
	readAloud: "",
};

module.exports = {
	parsers: {
		mathCommands: {
			mirror: mirrorParser,
		},
	},
	nodes: {
		mirror: mirrorNode,
	},
};
